import { render, staticRenderFns } from "./ICPFooter.vue?vue&type=template&id=f09da6dc&scoped=true&"
import script from "./ICPFooter.vue?vue&type=script&lang=js&"
export * from "./ICPFooter.vue?vue&type=script&lang=js&"
import style0 from "./ICPFooter.vue?vue&type=style&index=0&id=f09da6dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09da6dc",
  null
  
)

export default component.exports